import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../layouts/UserLayout'
import { Box, Card, CircularProgress, Divider, Typography } from '@mui/material'
import ScheduleIcon from '@mui/icons-material/Schedule'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { handleError } from '../utils/error'
import axios from 'axios'
import { getFromStorage } from '../utils/storage'
import { DOMAIN } from '../utils/api'
import { currentUserActions } from '../redux/store'
import { mainGreen, mainRed } from '../utils/color'
import PersonIcon from '@mui/icons-material/Person'

export default function Search() {
	const dispatch = useDispatch()
	const { phone } = useParams()
	const navigate = useNavigate()
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const [searchResult, setSearchResult] = useState()
	const [loadingSearch, setLoadingSearch] = useState(true)

	const getSearchURL = useCallback(
		function () {
			if (currentUser.permission?.includes('searchAllStores')) {
				return `${DOMAIN}/user/search-all-stores/${phone}`
			}
			if (currentUser.permission?.includes('searchByStore')) {
				return `${DOMAIN}/user/search-by-store/${phone}`
			}
			if (currentUser.permission?.includes('searchPersonal')) {
				return `${DOMAIN}/user/search-personal/${phone}`
			}
		},
		[currentUser.permission, phone],
	)

	const getSearch = useCallback(
		async function () {
			setLoadingSearch(true)
			const url = getSearchURL()
			try {
				const response = await axios({
					url,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setSearchResult(response.data)
				setLoadingSearch(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[getSearchURL, token, navigate, dispatch],
	)

	useEffect(() => {
		getSearch()
	}, [getSearch])

	return (
		<UserLayout>
			{loadingSearch ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Card
					sx={{
						padding: '20px 20px 10px 20px',
						background: '#fff',
					}}>
					{searchResult?.orders.length === 0 &&
						searchResult?.timerOrders.length === 0 &&
						searchResult?.deletedOrders.length === 0 &&
						searchResult?.guestOrders?.length === 0 && (
							<Typography
								sx={{
									padding: '2px 10px',
									borderRadius: '5px',
									color: '#fff',
									background: mainGreen,
									display: 'inline-block',
									mb: 1,
								}}>
								KHÔNG TÌM THẤY KẾT QUẢ!
							</Typography>
						)}
					{(searchResult?.orders.length > 0 ||
						searchResult?.timerOrders.length > 0 ||
						searchResult?.deletedOrders.length > 0 ||
						searchResult?.guestOrders?.length > 0) && (
						<>
							<Typography
								sx={{
									padding: '2px 10px',
									borderRadius: '5px',
									color: '#fff',
									background: mainGreen,
									display: 'inline-block',
								}}>
								TÌM ĐƯỢC{' '}
								{searchResult?.orders.length +
									searchResult?.timerOrders.length +
									searchResult?.deletedOrders.length +
									searchResult?.guestOrders?.length}{' '}
								KẾT QUẢ
							</Typography>
							<Typography
								sx={{
									fontStyle: 'italic',
									paddingTop: '4px',
									pb: 1,
									fontSize: '12px',
								}}>
								(* Chọn để xem chi tiết)
							</Typography>
							<Divider />
						</>
					)}
					{searchResult?.timerOrders.map((result, index) => {
						return (
							<Fragment key={index}>
								<Box
									sx={{
										mb: 2,
										mt: 2,
										cursor: 'pointer',
										display: 'flex',
									}}
									onClick={() => {
										navigate(`/user/search/timer-detail/${result.id}`)
									}}>
									<ScheduleIcon
										sx={{
											fontSize: '20px',
											color: mainGreen,
											marginRight: '5px',
										}}
									/>
									<Typography>
										<span style={{ fontWeight: 'bold', marginRight: '5px' }}> {result?.store}</span>
										Đơn hẹn lúc
										<span
											style={{
												marginLeft: '5px',
												fontSize: '14px',
												color: '#fff',
												background: mainGreen,
												padding: '2px 5px',
												borderRadius: '10px',
											}}>
											{result?.timerOrders?.timer.hours}:{result?.timerOrders?.timer.minutes} -{' '}
											{result?.timerOrders?.timer.date}/{result?.timerOrders?.timer.month}/
											{result?.timerOrders?.timer.year.toString().slice(2, 4)}
										</span>
									</Typography>
								</Box>
								<Divider />
							</Fragment>
						)
					})}
					{searchResult?.deletedOrders.map((result, index) => {
						return (
							<Fragment key={index}>
								<Box
									sx={{
										mb: 2,
										mt: 2,
										cursor: 'pointer',
										display: 'flex',
									}}
									onClick={() => {
										navigate(`/user/search/deleted-detail/${result.id}`)
									}}>
									<DeleteOutlinedIcon
										sx={{
											fontSize: '22px',
											color: mainRed,
											marginRight: '5px',
										}}
									/>
									<Typography>
										<span style={{ fontWeight: 'bold' }}>{result.store}</span> Đơn{' '}
										<span style={{ fontWeight: 'bold' }}>
											{result.deletedOrders.orderData.shiftCode}
											{result.deletedOrders.orderData.shiftIndex}
										</span>
										-<span style={{ fontWeight: 'bold' }}>{result.deletedOrders.orderData.shiftDay}</span>
										<span style={{ color: mainGreen, fontWeight: 'bold' }}> đã xóa</span>
									</Typography>
								</Box>
								<Divider />
							</Fragment>
						)
					})}
					{searchResult?.orders.map((result, index) => {
						return (
							<Fragment key={index}>
								<Typography
									sx={{ mb: 2, mt: 2, cursor: 'pointer' }}
									onClick={() => {
										navigate(`/user/search/detail/${result._id}`)
									}}>
									<span style={{ fontWeight: 'bold' }}>{result.store?.name}</span> Đơn{' '}
									<span style={{ fontWeight: 'bold' }}>
										{result.shiftCode}
										{result.shiftIndex}
									</span>
									-<span style={{ fontWeight: 'bold' }}>{result.shiftDay}</span>
									{result.status === 'create' && (
										<>
											{' '}
											<span style={{ color: mainGreen, fontWeight: 'bold' }}> chờ xử lý</span>
										</>
									)}
									{result.status === 'produce' && (
										<>
											{result.producer.produceEnd && <span style={{ color: mainGreen, fontWeight: 'bold' }}> đã </span>}
											{!result.producer.produceEnd && (
												<span style={{ color: mainGreen, fontWeight: 'bold' }}> đang </span>
											)}
											<span style={{ color: mainGreen, fontWeight: 'bold' }}> xử lý</span>
										</>
									)}
									{result.status === 'ship' && (
										<>
											{!result.shipper.produceEnd && (
												<span style={{ color: mainGreen, fontWeight: 'bold' }}> đang </span>
											)}
											<span style={{ color: mainGreen, fontWeight: 'bold' }}> giao</span>
										</>
									)}
									{result.status === 'success' && (
										<>
											<span style={{ color: mainGreen, fontWeight: 'bold' }}> giao thành công</span>
										</>
									)}
									{result.edited?.value && (
										<span
											style={{
												fontStyle: 'italic',
												fontWeight: 'bold',
												color: mainGreen,
											}}>
											{' '}
											(Đã chỉnh sửa)
										</span>
									)}
								</Typography>
								<Divider />
							</Fragment>
						)
					})}
					{searchResult?.guestOrders?.map((result, index) => {
						return (
							<Fragment key={index}>
								<Box
									sx={{
										mb: 2,
										mt: 2,
										cursor: 'pointer',
										display: 'flex',
									}}
									onClick={() => {
										navigate(`/user/search/guest-detail/${result._id}`, { state: { result } })
									}}>
									<PersonIcon
										sx={{
											fontSize: '20px',
											color: mainGreen,
											marginRight: '5px',
										}}
									/>
									<Typography>
										<span style={{ fontWeight: 'bold', marginRight: '5px' }}> {`${result?.store?.name ?? result?.store ?? ''}`}</span>
										{`Đơn ${result.source?.toUpperCase()} khách đặt giao lúc `}
										<span
											style={{
												marginLeft: '5px',
												fontSize: '14px',
												color: '#fff',
												background: mainGreen,
												padding: '2px 5px',
												borderRadius: '10px',
											}}>
											{`${result.shippingTime ?? '...'}`}
										</span>
									</Typography>
								</Box>
								<Divider />
							</Fragment>
						)
					})}
				</Card>
			)}
		</UserLayout>
	)
}
